import React from "react";
import { Image as AntdImage } from "antd";
import type { ImageProps as AntdImageProps } from "antd";

export type ImageProps = AntdImageProps;

const Image = AntdImage as unknown as React.ComponentType<ImageProps>;

export default Image;
